import React from 'react';
import MonthGrid from './MonthGrid';
import WeekNumberColumn from './WeekNumberColumn';
import { generateMonthDays } from '../../utils/date-utils';

// Get week start dates for week number column
function getWeekStarts(days) {
  const weeks = [];
  for (let i = 0; i < days.length; i += 7) {
    weeks.push(days[i]);
  }
  return weeks;
}

export default function MonthView({ 
  currentDate, 
  jobs = [], 
  events = [],
  forecastByDate = {},
  dayNotes = {},
  onDayClick,
  onJobClick,
  onEventClick,
  onJobDrop
}) {
  const year = new Date(currentDate).getFullYear();
  const month = new Date(currentDate).getMonth();
  
  const days = generateMonthDays(year, month);
  const weeks = getWeekStarts(days);

  return (
    <div style={{ display: 'flex' }}>
      {/* Week Numbers */}
      <WeekNumberColumn weeks={weeks} />

      {/* Calendar Grid */}
      <div style={{ flex: 1 }}>
        <MonthGrid
          days={days}
          currentMonth={month}
          jobs={jobs}
          events={events}
          forecastByDate={forecastByDate}
          dayNotes={dayNotes}
          onDayClick={onDayClick}
          onJobClick={onJobClick}
          onEventClick={onEventClick}
          onJobDrop={onJobDrop}
        />
      </div>
    </div>
  );
}